var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongoDbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4149 82.8298C64.2877 82.8298 82.8298 64.2877 82.8298 41.4149C82.8298 18.5421 64.2877 0 41.4149 0C18.5421 0 0 18.5421 0 41.4149C0 64.2877 18.5421 82.8298 41.4149 82.8298Z",
    fill: "#13AA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4853 36.3545C49.8694 24.8093 43.6871 21.0132 43.0214 19.5629C42.2934 18.5397 41.5557 16.7197 41.5557 16.7197C41.5436 16.6889 41.5242 16.6347 41.5015 16.5822C41.4263 17.6054 41.3875 18.0001 40.42 19.0323C38.922 20.2035 31.236 26.6528 30.6107 39.7696C30.0275 52.0032 39.4477 59.2929 40.7217 60.2223L40.8665 60.325V60.3161C40.8746 60.3776 41.271 63.2281 41.5492 66.2485H42.5474C42.7816 64.1135 43.1326 61.9929 43.5989 59.8963L43.6798 59.8437C44.2497 59.4351 44.793 58.9907 45.3065 58.5131L45.3647 58.4605C48.0729 55.9586 52.9416 50.1719 52.8938 40.9458C52.8838 39.4067 52.7471 37.8712 52.4853 36.3545ZM41.4433 53.3152C41.4433 53.3152 41.4433 36.1572 42.0095 36.1604C42.4511 36.1604 43.023 58.2923 43.023 58.2923C42.2368 58.1976 41.4433 54.6499 41.4433 53.3152Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongoDbLogo);
export default __webpack_public_path__ + "static/media/MongoDB-Logo.2bfa1f56e966096eae802e1b0a2b6f02.svg";
export { ForwardRef as ReactComponent };